import { ofType, combineEpics, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Safescarf from '../../../api/safescarf';
import { handleError } from '../../errorHandler';
import { enqueueSnackbar } from '../../notifier/actions';
import { fetchProductTypeMembers } from '../productTypeMembers/actions';

import {
  CREATE_PRODUCT_TYPE_STARTED,
  createProductTypeFulfilled,
  FETCH_PRODUCT_TYPES_STARTED,
  fetchProductTypesFulfilled,
  UPDATE_PRODUCT_TYPE_STARTED,
  updateProductTypeFulfilled,
} from './actions';

// PRODUCT_TYPES
const createProductTypeEpic: Epic = action$ =>
  action$.pipe(
    ofType(CREATE_PRODUCT_TYPE_STARTED),
    mergeMap((action: { payload: Record<string, unknown> & { id: string; } }) =>
      from(Safescarf.createSafescarfProductType(action.payload)).pipe(
        mergeMap((response: { data: unknown }) =>
          of(
            createProductTypeFulfilled(response.data),
            enqueueSnackbar({
              message: 'safescarfProductTypeCreated',
              options: { variant: 'success' },
            }),
            fetchProductTypeMembers()
          )
        ),
        catchError(handleError)
      )
    )
  );

const fetchProductTypesEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_PRODUCT_TYPES_STARTED),
    mergeMap(() =>
      from(Safescarf.fetchSafescarfProductTypes()).pipe(
        mergeMap((response: { data: unknown }) => of(fetchProductTypesFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

const updateProductTypeEpic: Epic = action$ =>
  action$.pipe(
    ofType(UPDATE_PRODUCT_TYPE_STARTED),
    mergeMap((action: { payload: Record<string, unknown> & { id: string; } }) =>
      from(Safescarf.updateSafescarfProductType(action.payload)).pipe(
        mergeMap((response: { data: unknown }) =>
          of(
            updateProductTypeFulfilled(response.data),
            enqueueSnackbar({
              message: 'safescarfProductTypeUpdated',
              options: { variant: 'success' },
            })
          )
        ),
        catchError(handleError)
      )
    )
  );

export default combineEpics(createProductTypeEpic, fetchProductTypesEpic, updateProductTypeEpic);
